const initialState = {};

const JOB_FAVORITE_ADD = 'JOB_FAVORITE_ADD';
const JOB_FAVORITE_ADDED = 'JOB_FAVORITE_ADDED';
// const JOB_FAVORITE_ADD_FINALLY = 'JOB_FAVORITE_ADD_FINALLY';
const JOB_FAVORITE_DELETE = 'JOB_FAVORITE_DELETE';
const JOB_FAVORITE_DELETED = 'JOB_FAVORITE_DELETE';
// const JOB_FAVORITE_DELETE_FINALLY = 'JOB_FAVORITE_DELETE_FINALLY';

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case JOB_FAVORITE_ADDED:
      return { ...state, [action.result.jobId]: new Date().toISOString() };

    case JOB_FAVORITE_DELETED: {
      const { [action.result.jobId]: deleted, ...rest } = state;
      return rest;
    }
  }
  return state;
}

export const actions = {
  addFavoriteJob(jobId, onSuccess, onFailure) {
    return {
      type: JOB_FAVORITE_ADD,
      types: [null, JOB_FAVORITE_ADDED],
      callApi: client => client.post('/user/profile/favorite-jobs', { jobId }),
      onSuccess: onSuccess ? [onSuccess] : [],
      onFailure: onFailure ? [onFailure] : [],
    };
  },

  deleteFavoriteJob(jobId, onSuccess, onFailure) {
    return {
      type: JOB_FAVORITE_DELETE,
      types: [null, JOB_FAVORITE_DELETED],
      callApi: client => client.delete(`/user/profile/favorite-jobs/${jobId}`),
      onSuccess: onSuccess ? [onSuccess] : [],
      onFailure: onFailure ? [onFailure] : [],
    };
  },
};

export const selectors = {
  isJobFavorite(state, jobId) {
    if (!state.favoriteJobs) {
      return false;
    }

    return !!state.favoriteJobs[jobId];
  },
  getFavoriteDate(state, jobId) {
    if (!(jobId && state.favoriteJobs)) {
      return null;
    }

    return state.favoriteJobs[jobId];
  }
};
